import sameHeight from '../components/sameHeight';
import scrollPosition from '../components/scrollPosition';
import map from '../components/map';

export default function home() {
	var menuLinks = document.querySelectorAll(".site-menu-dropdown .action-menu-link"),
		homeMap = document.querySelector("#home-map"),
		lastActive,
		mapPlace,
		mapCenter;

	sameHeight(document.querySelectorAll(".home-about-us .feature-description"));

	scrollPosition(document.querySelectorAll(".scroll-event"), {
		offset: 2,
		callback: function (data) {
			if (data.index !== lastActive) {
				[].forEach.call(menuLinks, function(elem) {
					elem.classList.remove("active");
				});
			}
			menuLinks[data.index].classList.add("active");
			lastActive = data.index;
		}
	});

	mapPlace = {
		"lat": parseFloat(homeMap.getAttribute("data-place-lat"), 10),
		"lng": parseFloat(homeMap.getAttribute("data-place-lng"), 10)
	};

	mapCenter = {
		"lat": parseFloat(homeMap.getAttribute("data-center-lat"), 10),
		"lng": parseFloat(homeMap.getAttribute("data-center-lng"), 10)
	};

	map(homeMap.id, {
		API_KEY: homeMap.getAttribute("data-api-key"),
		place: mapPlace,
		center: window.isMobile || window.innerWidth <= 768 ? mapPlace : mapCenter,
		title: homeMap.getAttribute("data-place-title")
	});
}


//////////////////
// WEBPACK FOOTER
// ./src/js/pages/home.js
// module id = 13
// module chunks = 0